import { getBaseUrl } from '../config/apiConfig';

/**
 * CSRF Service
 * Manages CSRF token fetching and caching for API requests
 */
class CsrfService {
  constructor() {
    this.token = null;
  }

  /**
   * Fetch a new CSRF token from the backend
   */
  async fetchToken() {
    try {
      const response = await fetch(`${getBaseUrl()}/api/csrf-token`, {
        credentials: 'include', // Important: include cookies
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch CSRF token: ${response.status}`);
      }

      const data = await response.json();
      this.token = data.csrfToken;
      // console.log('🔒 CSRF token fetched successfully');
      return this.token;
    } catch (error) {
      console.error('❌ Failed to fetch CSRF token:', error);
      throw error;
    }
  }

  /**
   * Get the current cached token
   */
  getToken() {
    return this.token;
  }

  /**
   * Ensure a token exists, fetch if necessary
   */
  async ensureToken() {
    if (!this.token) {
      await this.fetchToken();
    }
    return this.token;
  }

  /**
   * Clear the cached token (e.g., on logout)
   */
  clearToken() {
    this.token = null;
    // console.log('🔒 CSRF token cleared');
  }

  /**
   * Refresh the token (fetch a new one)
   */
  async refreshToken() {
    this.token = null;
    return this.fetchToken();
  }
}

// Create singleton instance
export const csrfService = new CsrfService();
export default csrfService;
